import { Voter } from '@/interfaces';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initiateVoterSearch, selfTransfer, verifyOtp } from '../thunks';

interface VoterState {
  voter: Voter | null;
  isLoading: boolean;
  error: string | null;
  token: string | null;
}

const initialState: VoterState = {
  voter: null,
  isLoading: false,
  error: null,
  token: null
};

const voterSlice = createSlice({
  name: 'voter',
  initialState,
  reducers: {
    clearVoterData: (state) => {
      state.voter = null;
      state.error = null;
      state.token = null;
    },
    setVoterData: (state, action: PayloadAction<Voter>) => {
      state.voter = action.payload;
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    }
  },
  extraReducers: (builder) => {
    // Initiate search
    builder.addCase(initiateVoterSearch.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(initiateVoterSearch.fulfilled, (state) => {
      state.isLoading = false;
    });
    builder.addCase(initiateVoterSearch.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload as string;
    });

    // Verify OTP
    builder.addCase(verifyOtp.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(verifyOtp.fulfilled, (state, action) => {
      state.isLoading = false;
      if (action.payload.data) {
        state.voter = action.payload.data.voter;
        if (action.payload.data.token) {
          state.token = action.payload.data.token;
        }
      }
    });
    builder.addCase(verifyOtp.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload as string;
    });

    // Self transfer
    builder.addCase(selfTransfer.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(selfTransfer.fulfilled, (state, action) => {
      state.isLoading = false;
      state.voter = action.payload.data;
    });
    builder.addCase(selfTransfer.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload as string;
    });
  }
});

export const { clearVoterData, setVoterData, setToken } = voterSlice.actions;
export const voterReducer = voterSlice.reducer;
